export class AnalyticsLists {
  public static productCatalog(storeName: string) {
    return `Product listing - ${storeName}`;
  }
  public static webShopHome(storeName: string) {
    return `Webshop home - ${storeName}`;
  }
}
